import React from 'react';
import { Box, Typography, Grid, Chip } from '@mui/material';
import Section from '../../../shared/Section/Section';
import styles from './styles';

const gridItemsReorder = (idx, length) => {
  const middle = Math.ceil(length / 2);
  return idx < middle ? idx * 2 : (idx - middle) * 2 + 1;
};

function Details({ details, title, subtitle, bg }) {
  return (
    <Section title={title} subtitle={subtitle} bg={bg} withoutBg={!bg}>
      <Grid container spacing={3}>
        {details.map((detail, index) => {
          const { Icon } = detail;
          return (
            <Grid
              key={`${detail}${index}`}
              item
              xs={12}
              md={6}
              order={{
                xs: index,
                md: gridItemsReorder(index, details.length),
              }}
              pt={{ xs: !index && '32px !important' }}
            >
              <Box
                sx={styles.itemGrid(
                  gridItemsReorder(index, details.length) % 2,
                )}
              >
                <Typography variant="desktopP2" component="p">
                  {detail.title}
                </Typography>
                <Box sx={styles.infoContainer}>
                  <Typography
                    variant="desktopH3"
                    color="kit.text.main"
                    sx={{
                      display: 'flex',
                      whiteSpace: 'break-spaces',
                      lineHeight: {
                        sm: '40px !important',
                      },
                    }}
                  >
                    <Icon title={detail.title} sx={styles.icon} />
                    {detail.info}
                  </Typography>
                  {detail.format && (
                    <Box sx={styles.chip}>
                      <Chip
                        color="secondary"
                        size="small"
                        variant="status"
                        label={detail.format}
                        sx={{ ml: 1 }}
                      />
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );
}

export default Details;
